import { render, staticRenderFns } from "./ClientContractHistory.vue?vue&type=template&id=563a92d2&"
import script from "./ClientContractHistory.vue?vue&type=script&lang=js&"
export * from "./ClientContractHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports